import { ContentContext } from "@/data/context/content";
import { Container, Grid, Button, Box, Stack } from "@mui/material";
import { FC, useContext, useEffect } from "react";
import { HelloRetailOverLaySX, HelloRetailOverLayContentSX, OverLayShadowSX, searchPopupCloseBtnSX } from "../../styles/HelloRetailSearch/HelloRetailProductList";
import CloseIcon from '@mui/icons-material/Close';
import { useDeviceType } from "@/data/deviceDetection";
import { HelloRetailProductGrid } from "@/components/content/HelloRetailCatalogEntryList/parts/ProductGrid";
import { FacetNavigationList } from "@/components/content/HelloRetailFacetNavigation/parts/FacetNavigationList";
import { useHelloRetailSearch } from "@/data/Content/HelloRetailSearch";
import { HelloRetailCategoryList } from "@/components/content/Header/parts/HelloRetail/CategoryList";
import { PopularProducts } from "./PopularProducts";

export const ProductOverlay: FC = () => {
    const { isMobile } = useDeviceType();

    const {
        showOverLay,
        closeOverLay,
        products,
    } = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;

    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => { 
            if (e.key === "Escape" && showOverLay) {
                closeOverLay();
                document.querySelector<HTMLInputElement>("#header_search_input")?.blur();
            } 
        }
        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [showOverLay]);

    return (
        <>
        <Box sx={OverLayShadowSX} onClick={closeOverLay}></Box>
        <Stack sx={HelloRetailOverLaySX} aria-modal="true" role="dialog">
            <Stack sx={HelloRetailOverLayContentSX} id="overlayDialogID">                
                <Container>
                    {products?.length ?
                        <Grid container spacing={isMobile?0:6}>
                            <Grid item md={3} maxWidth="100%">
                                <FacetNavigationList />
                            </Grid>
                            <Grid item md={9} maxWidth="100%">
                                <HelloRetailCategoryList />
                                <HelloRetailProductGrid />
                            </Grid>
                        </Grid>
                    :   <PopularProducts />
                    }
                </Container>
                <Button sx={searchPopupCloseBtnSX} onClick={closeOverLay}>
                    <CloseIcon sx={{ fontSize: 20 }} />
                </Button>
            </Stack>
        </Stack>
        </>
    );
}